<div id="myMap" xsMap [options]="defaultOptions" [style]="mapStyle" (onMapReady)="onMapReady($event)"></div>

<ssp-map-locate-device-button
  [locateDeviceInProgress]="locateDeviceInProgress"
  (locateDevice)="locateDevice()"
></ssp-map-locate-device-button>

<ssp-map-locate-user-button
  [locateUserInProgress]="locateUserInProgress"
  (locateUser)="locateUser()"
></ssp-map-locate-user-button>

<ssp-map-zoom-buttons [currentZoom]="currentZoom" (zoomOut)="zoomOut()" (zoomIn)="zoomIn()"></ssp-map-zoom-buttons>
<ssp-map-view-type-button [viewType]="mapStyle" (toggleViewType)="toggleSatellite()"></ssp-map-view-type-button>
